import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from '../../environments/environment';
export const msalConfig: Configuration = {
    auth: {
        clientId: environment.msal.uiClientId,
        authority: environment.msal.authority,
        // Must point at the /redirect bridge route (MSAL v5): Entra login pages
        // enforce COOP, so popups can no longer reach the opener directly — the
        // bridge page relays the auth response over BroadcastChannel instead.
        //
        // No postLogoutRedirectUri, here or per call: signing out clears the
        // local session only (AuthService.logout) and never contacts Entra's
        // end-session endpoint, so this is the sole redirect URI the app
        // registration needs.
        redirectUri: environment.msal.redirectUri
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
        allowRedirectInIframe: true,
        /*
         * How long to wait for the redirect bridge to relay a popup response.
         * COOP leaves MSAL unable to observe the popup, so this timer is the
         * only thing that ends an unfinished popup flow — it has to cover the
         * user's whole interaction, including an MFA push approval. MSAL's
         * 60s default is short for that and would fail sign-ins the user
         * actually completed, so allow three minutes. Users are not stuck
         * waiting on it: the login page offers a Cancel action that abandons
         * the attempt immediately (see LoginComponent.cancelSignIn).
         */
        popupBridgeTimeout: 180000,
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                // Only log errors and warnings in production
                if (containsPii) return;

                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        // Suppress info, verbose, and debug logs
                        return;
                }
            },
            logLevel: LogLevel.Warning,
        },
    },
};

export { apiRequest, loginRequest } from './auth-scopes.config';
